import webApi, { baseURL } from "../../WebApi/WebApi";

//Add Accounting Dimensions
export const AddAccountingDimensions = async (data, onSuccess, onFailure) => {
    try {
        const res = await webApi.post(`/customer/account-information/add-account-info`,data);
        if (res.status === 200) {
            const r = res.data;
            return onSuccess(r);
        } else {
            onFailure("Something Wrong! Please Try again later" + res.data);
        }
    } catch (error) {
      //  console.log(error)
    }
}

//list Accounting Dimensions
export const listAccountingDimensions = async (onSuccess, onFailure) => {
    try {
        const res = await webApi.get(`/customer/account-information/list-account-info`);
        if (res.status === 200) {
            const r = res.data;
            return r;
        } else {
            onFailure("Something Wrong! Please Try again later" + res.data);
        }
    } catch (error) {
      //  console.log(error)
    }
}

//Delete Accounting Dimensions
export const DeleteAccountingDimensions = async (id, onSuccess, onFailure) => {
    try {
        const res = await webApi.post(`/customer/account-information/delete-account-info`,{accountId:id});
        if (res.status === 200) {
            const r = res.data;
            return r;
        } else {
            onFailure("Something Wrong! Please Try again later" + res.data);
        }
    } catch (error) {
      //  console.log(error)
    }
}

// /customer/account-dimension/add-edit-account-dimension
export const addEditAccountDimension = async (data,onSuccess,onFailure)=>{
    try {
        const res = await webApi.post(`/customer/account-dimension/add-edit-account-dimension`,data);
        if (res.status === 200) {
            const r = res.data;
            return onSuccess(r);
        } else {
            onFailure("Something Wrong! Please Try again later" + res.data);
        }
    } catch (error) {
      //  console.log(error)
    }
}

// /customer/account-dimension/get-account-dimension-by-id
export const getAccountDimensionById = async (onSuccess,onFailure)=>{
    try {
        const res = await webApi.get(`/customer/account-dimension/list-account-dimension`);
        if (res.status === 200) {
            const r = res.data;
            return onSuccess(r);
        } else {
            onFailure("Something Wrong! Please Try again later" + res.data);
        }
    } catch (error) {
      //  console.log(error)
    }
}

export const getAccountDimensionSingle = async (id,onSuccess,onFailure)=>{
    try {
        const res = await webApi.post(`/customer/account-dimension/get-account-dimension-by-id`,{id});
        if (res.status === 200) {
            const r = res.data;
            return onSuccess(r);
        } else {
            onFailure("Something Wrong! Please Try again later" + res.data);
        }
    } catch (error) {
      //  console.log(error)
    }
}

